import { _ } from '../model/ccc'
import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { getPersonRelationshipFormatted } from './getPersonRelationshipFormatted'
import { isDead } from './isDead'

export function getPersonNameFormatted(
	data: IData,
	person: IPerson,
	altAlive?: string,
) {
	return (
		<>
			{person.honorific ? <small>{person.honorific}</small> : ''}{' '}
			{person.lastName?.includes('Parditka') ? (
				<span class={_.ccc_parditka}>{person.lastName}</span>
			) : (
				(person.lastName ?? '')
			)}{' '}
			<b>{person.firstName ?? ''}</b>{' '}
			{person.nickname ? <small>({person.nickname})</small> : ''}{' '}
			{isDead(data, person) ? '†' : (altAlive ?? '')}{' '}
			{getPersonRelationshipFormatted(person)}{' '}
			{person.cloudId === 1 ? (
				''
			) : (
				<span class={_.ccc_tag__cloud} title={`${person.cloudId}. felhő`}>
					{(person.cloudId ?? 0) + ''}
				</span>
			)}
		</>
	)
}
